import React from "react"
import { Grid } from "@mui/material"

import { AppCrudTable } from "@components"
import { userSettingTierData } from "../@signals"
import { actionsColumn, nameColumn, providersColumn } from "./columns"
import UserSettingTierTabButton from "./Button"
import UserSettingTierDrawer from "./Drawer"
import { isTourDemoActive } from "@signals/app"


export default function UserSettingTierTable() {

	return <Grid container spacing={1}>
		<Grid item xs={12} sx={{  display: 'flex', justifyContent: 'flex-end'  }}>
			<UserSettingTierTabButton />
		</Grid>

		{(!isTourDemoActive.value || !!userSettingTierData.value?.length) && <Grid item xs={12}>
			<AppCrudTable
				title="Your Tiers"
				data={userSettingTierData.value}
				columns={[
					nameColumn(),
					providersColumn(),
					actionsColumn()
				]}
			/>
		</Grid>}

		<UserSettingTierDrawer />
	</Grid>
}